import React from 'react';
import Link from 'gatsby-link';
import { withPrefix } from 'gatsby-link';
import './style.scss';

class Paper extends React.Component {
  render() {
    const {
      title,
      date,
      category,
      status,
      conference,
      conferenceLink,
      arxivLink,
      slidesLink,
      datasetsLink,
      videoLink,
      acmLink,
      pdfLink,
      authors,
      description
    } = this.props.data.node.frontmatter;

    const { slug, categorySlug } = this.props.data.node.fields;

    let conferenceBlurb;

    const maybePrefix = (link) => {
      // console.log("Link is " + link);
      // console.log("Index of is " + link.indexOf('://'));
      if (link.indexOf('://') !== -1) {
        // console.log("  No prefix.");
        return link;
      } else {
        // console.log("  With prefix.");
        return withPrefix(link);
      }
    };

    const makeBlurb = (name, link, nospace) => {
      if (link && link !== '#') {
        if (nospace) {
          return (
            <a className="paper__linkout" href={maybePrefix(link)}>
              {name}
            </a>
          );
        }
        return (
          <a className="paper__linkout paper__linkspace" href={maybePrefix(link)}>
            {name}
          </a>
        );
      }
      return undefined;
    };

    const pdfBlurb = makeBlurb('pdf', pdfLink, true);
    const acmBlurb = makeBlurb('acm', acmLink);
    const arxivBlurb = makeBlurb('arXiv', arxivLink);
    const datasetsBlurb = makeBlurb('datasets', datasetsLink);
    const slidesBlurb = makeBlurb('slides', slidesLink);
    const videoBlurb = makeBlurb('video', videoLink);

    const authorsBlock = (
      <span className="paper__meta-authors">
        {authors.map((author) => (
          <a href={author.link} key={author.name}>{author.name}</a>
        ))}
      </span>
    );

    if (status === 'To Appear At' || status === 'Published In') {
      conferenceBlurb = <a href={conferenceLink} className="paper__meta-link">{conference}</a>;
    }

    return (
      <div className="paper">
        <div className="paper__meta">
          <span className="paper__meta-status">
            {status} {conferenceBlurb}
          </span>
          <span className="paper__meta-divider" />
          <span className="paper__meta-category" key={categorySlug}>
            <strong>
              <Link to={categorySlug} className="paper__meta-category-link">
                #{category}
              </Link>
            </strong>
          </span>
          <hr className="paper__meta-hr" />
        </div>
        <h2 className="paper__title">
          <Link className="paper__title-link" to={slug}>{title}</Link>
        </h2>
        {authorsBlock}
        <p className="paper__description">{description}</p>
        {pdfBlurb}
        {acmBlurb}
        {arxivBlurb}
        {datasetsBlurb}
        {slidesBlurb}
        {videoBlurb}
      </div>
    );
  }
}

export default Paper;



// WEBPACK FOOTER //
// ./src/components/Paper/index.jsx